import { render, staticRenderFns } from "./NameStep.vue?vue&type=template&id=99a4a41a&scoped=true"
import script from "./NameStep.vue?vue&type=script&lang=ts"
export * from "./NameStep.vue?vue&type=script&lang=ts"
import style0 from "./NameStep.vue?vue&type=style&index=0&id=99a4a41a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a4a41a",
  null
  
)

export default component.exports